export default __webpack_public_path__ + "static/media/header-1920.ed669308.png";